import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AssetTypename_AudioAsset_Fragment = { __typename: 'AudioAsset', id: string };

export type AssetTypename_DocumentAsset_Fragment = { __typename: 'DocumentAsset', id: string };

export type AssetTypename_FileAsset_Fragment = { __typename: 'FileAsset', id: string };

export type AssetTypename_FolderAsset_Fragment = { __typename: 'FolderAsset', id: string };

export type AssetTypename_ImageAsset_Fragment = { __typename: 'ImageAsset', id: string };

export type AssetTypename_InteractiveAsset_Fragment = { __typename: 'InteractiveAsset', id: string };

export type AssetTypename_InteractiveLiveAsset_Fragment = { __typename: 'InteractiveLiveAsset', id: string };

export type AssetTypename_ModelAsset_Fragment = { __typename: 'ModelAsset', id: string };

export type AssetTypename_UnsupportedAsset_Fragment = { __typename: 'UnsupportedAsset', id: string };

export type AssetTypename_VersionStackAsset_Fragment = { __typename: 'VersionStackAsset', id: string };

export type AssetTypename_VideoAsset_Fragment = { __typename: 'VideoAsset', id: string };

export type AssetTypenameFragment = AssetTypename_AudioAsset_Fragment | AssetTypename_DocumentAsset_Fragment | AssetTypename_FileAsset_Fragment | AssetTypename_FolderAsset_Fragment | AssetTypename_ImageAsset_Fragment | AssetTypename_InteractiveAsset_Fragment | AssetTypename_InteractiveLiveAsset_Fragment | AssetTypename_ModelAsset_Fragment | AssetTypename_UnsupportedAsset_Fragment | AssetTypename_VersionStackAsset_Fragment | AssetTypename_VideoAsset_Fragment;

export const AssetTypename = /*#__PURE__*/ gql`
    fragment AssetTypename on Asset {
  __typename
  id
}
    ` as unknown as DocumentNode<AssetTypenameFragment, unknown>;

        

        
export const useAssetTypenameFragment = (
  input: string | Omit<UseFragmentOptions<AssetTypenameFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Asset' } };
    return input;
  })();

  return useFragment<AssetTypenameFragment>({
    fragment: AssetTypename,
    fragmentName: 'AssetTypename',
    ...options,
  });
};
  
        